/** £20 off the trial box. The control variant of the Meta offer AB test. */
export const META_CONTROL_DISCOUNT_CODE = "FEAST20" as const;

/** 30% off trial/checkout box. When this code is applied at checkout,
 * two companion discounts are also applied:
 * {@link META_30_FIRST_RECURRING_DISCOUNT_CODE} and
 * {@link FREE_SPRINKLES_FOR_LIFE_DISCOUNT_CODE}. */
export const META_30_TRIAL_DISCOUNT_CODE = "META_30_TRIAL" as const;

/** 30% off the first recurring box. Companion discount to
 * {@link META_30_TRIAL_DISCOUNT_CODE}, applied automatically at checkout. */
export const META_30_FIRST_RECURRING_DISCOUNT_CODE = "META_30_FIRST_RECURRING" as const;

/** Free sprinkles for life on all recurring orders.
 * Applied as a companion discount alongside META_30_TRIAL during checkout.
 * Uses the ONETIME special condition so it stacks with other discounts. */
export const FREE_SPRINKLES_FOR_LIFE_DISCOUNT_CODE = "FREE_SPRINKLES_FOR_LIFE_2607" as const;

export type TMetaOfferVariant = "control" | "test";

/** Which side of the Meta offer AB test a discount code puts the user on,
 * or undefined if the code isn't part of the test. */
export const getMetaOfferVariant = (
  discountCode: string | undefined,
): TMetaOfferVariant | undefined => {
  if (discountCode === META_CONTROL_DISCOUNT_CODE) {
    return "control";
  }
  if (discountCode === META_30_TRIAL_DISCOUNT_CODE) {
    return "test";
  }
  return undefined;
};

export const isMetaOfferUser = (discountCode: string | undefined): boolean =>
  getMetaOfferVariant(discountCode) !== undefined;
